import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = [ "lightIcon", "darkIcon", "themeToggle" ]

  connect() {
    // default is dark theme
    if (localStorage.getItem('theme') === 'dark') {
      document.body.setAttribute('data-bs-theme', 'dark');
      this.enableLightButton();
    } else {
      document.body.setAttribute('data-bs-theme', 'light');
      this.enableDarkButton();
    }
  }

  toggleTheme(e) {
    if (localStorage.getItem('theme') === 'light') {
      document.body.setAttribute('data-bs-theme', 'dark');
      this.enableLightButton();
      localStorage.setItem('theme', 'dark');
    } else {
      document.body.setAttribute('data-bs-theme', 'light');
      this.enableDarkButton();
      localStorage.setItem('theme', 'light');
    }
  }

  enableDarkButton() {
    this.lightIconTarget.style.display = 'none';
    this.darkIconTarget.style.display = '';
  }

  enableLightButton() {
    this.lightIconTarget.style.display = '';
    this.darkIconTarget.style.display = 'none';
  }
}
